import { Module, ParameterValue } from '@philips-internal/oswald-ui-foundation/lib/context';

export interface ParametersModule {
  cdFunction: string;
  name: string;
  parameters: Map<string, ParameterValue>;
}

function availableModulesMapper(twsParameters: ParametersModule[]): Module[] {

  function getParameters(parameters: Map<string, ParameterValue>): Map<string, ParameterValue> {
    const parametersMap: Map<string, ParameterValue> = new Map();

    if (parameters) {
      for (const [key, value] of Object.entries(parameters)) {
        parametersMap.set(key, value);
      }
    }

    return parametersMap;
  }

  const modules: Module[] = twsParameters.map((twsParam: ParametersModule) => ({
    id: twsParam.cdFunction,
    name: twsParam.name,
    parameters: getParameters(twsParam.parameters)
  }));

  modules.push({
    id: 'user-details',
    name: 'user-details',
    parameters: new Map([])
  });

  return modules;
}

export {
  availableModulesMapper
};
